export const examples = [
  { name: 'JSCAD Logo', source: './examples/jscad.example.js' },
  { name: 'Primitive Shapes', source: './examples/primitives.example.js' },
  { name: 'Extrusions', source: './examples/extrusions.example.js' },
  { name: 'Hull Operations', source: './examples/hulls.example.js' },
  { name: 'Parametric Gear', source: './examples/gear.example.js' },
  { name: 'Nuts and Bolts', source: './examples/nuts-and-bolts.example.js' },
  { name: 'Text Shapes', source: './examples/text.example.js' },
  { name: 'Slicer', source: './examples/slicer.example.js' },
  { name: 'Balloons', source: './examples/balloons.example.js' },
  { name: 'Parameter Types', source: './examples/parameters.example.js' },
  { name: 'Import AMF', source: './examples/AMFImport/index.js' },
  { name: 'Import STL', source: './examples/STLImport/index.js' },
  { name: 'Import SVG', source: './examples/SVGImport/index.js' },
]
